export const storyInitialState = {
  stories: {
    data: [],
    loading: false,
    error: null,
    total: 0,
  },
  brandBaanStories: {
    data: [],
    loading: false,
    error: null,
    total: 0,
  },
  filters: {
    resourceCategoryFilter: {
      hasFilter: false,
      isOpen: false,
      selectedValue: '',
      platform: 'instagram',
      componentName: 'resourceCategoryFilter',
      translateKey: 'filter:resourceCategory',
      hasIncludeExclude: true,
      filterType: 'include',
    },
    resourcesFilter: {
      hasFilter: false,
      isOpen: false,
      selectedValue: 'include',
      selectedItems: {},
      hasIncludeExclude: true,
      platform: 'instagram',
      componentName: 'resourcesFilter',
      translateKey: 'filter:resourceSearch',
    },
  },
  selectedStoryIndex: null,
  storyDetailModal: false,
  isLeftOrRightKeyClicked: false,
  selectedFilter: 'resourceCategoryFilter',
  selectedStories: [],
};
